// استيراد دوال React لإدارة الحالات والمراجع والتأثيرات الجانبية
import { useEffect, useRef, useState } from "react";
// استيراد مكونات Form و FormGroup من React Bootstrap
import { Form, FormGroup } from "react-bootstrap";
// استيراد الأيقونات المطلوبة من Font Awesome
import { faUpload, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
// استيراد مكون عرض الأيقونات
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد روابط API الخاصة بالتصنيفات والمنتجات
import { CATEGORIES, Pro } from "../../../API/Api";
// استيراد مكون التحميل
import Loading from "../../../components/Loading/Loding";
// استيراد دوال التنقل والحصول على المعاملات من React Router
import { useNavigate, useParams } from "react-router-dom";
// استيراد سياق اللغة
import { useLanguage } from "../../../Context/LanguageContext";
// استيراد ملف الأنماط
import "../../../components/Dashboard/FormPage.css";

// المكون الرئيسي لتعديل المنتجات
export default function EditProducts ()
{
    // استيراد دالة الترجمة من سياق اللغة
    const { t } = useLanguage();

    // حالة لتخزين بيانات النموذج (التصنيف، العنوان، الوصف، السعر، الخصم، نبذة، المخزون)
    const [ formData, setFormData ] = useState( {
        category: "Selected category",
        title: "",
        description: "",
        price: "",
        discount: "",
        About: "",
        stock: "",
    } );

    // حالة لتخزين الصور الجديدة المضافة
    const [ images, setImages ] = useState( [] );
    // حالة لتخزين قائمة التصنيفات
    const [ categories, setCategories ] = useState( [] );
    // دالة للتنقل بين الصفحات
    const navigate = useNavigate();
    // حالة التحميل
    const [ loading, setLoading ] = useState( false );
    // حالة لتخزين الصور من الخادم
    const [ imagesFromServer, setImagesFromServer ] = useState( [] );

    // استخراج معرف المنتج من معاملات الرابط
    const { id } = useParams();

    // مرجع لفتح نافذة اختيار الملفات
    const openImage = useRef( null );
    // مصفوفة مراجع لتتبع تقدم رفع الصور
    const progress = useRef( [] );
    // مصفوفة لتخزين معرفات الصور
    const ids = useRef( [] );
    // عداد لتتبع عدد الصور
    const j = useRef( -1 );

    // تأثير جانبي لجلب بيانات المنتج عند تحميل المكون
    useEffect( () =>
    {
        // تفعيل حالة التحميل
        setLoading( true );
        // إرسال طلب GET لجلب بيانات المنتج باستخدام المعرف
        Axios.get( `/${ Pro }/${ id }` )
            .then( ( res ) =>
            {
                // تعبئة بيانات النموذج بالبيانات المسترجعة
                setFormData( res.data[ 0 ] );
                // تخزين صور المنتج من الخادم
                setImagesFromServer( res.data[ 0 ].images );
            } )
            .catch( ( error ) => console.log( error ) ) // معالجة الأخطاء
            .finally( () => setLoading( false ) ); // إلغاء حالة التحميل في النهاية
    }, [ id ] ); // إعادة التشغيل عند تغيير المعرف

    // تأثير جانبي لجلب قائمة التصنيفات
    useEffect( () =>
    {
        // إرسال طلب GET لجلب جميع التصنيفات
        Axios.get( `/${ CATEGORIES }` )
            .then( ( res ) => setCategories( res.data ) ) // تخزين التصنيفات
            .catch( ( error ) => console.log( "Error fetching categories:", error ) ); // معالجة الأخطاء
    }, [] ); // يتم التنفيذ مرة واحدة عند تحميل المكون

    // دالة غير متزامنة لحفظ التعديلات
    async function handleSave ( e )
    {
        // منع إعادة تحميل الصفحة
        e.preventDefault();
        // تفعيل حالة التحميل
        setLoading( true );
        try
        {
            // إرسال طلب POST لتحديث بيانات المنتج
            await Axios.post( `/${ Pro }/edit/${ id }`, formData );
            // التوجيه إلى صفحة قائمة المنتجات بعد النجاح
            navigate( "/dashboard/products" );
        } catch ( error )
        {
            // طباعة تفاصيل الخطأ في وحدة التحكم
            console.error( "Error response:", error.response );
            // إلغاء حالة التحميل في حالة الخطأ
            setLoading( false );
        }
    }

    // دالة لفتح نافذة اختيار الملفات
    function handleOpenImage ()
    {
        openImage.current.click();
    }

    // دالة معالجة تغيير المدخلات النصية
    const handleChange = ( e ) =>
    {
        // تحديث بيانات النموذج حسب اسم الحقل والقيمة
        setFormData( { ...formData, [ e.target.name ]: e.target.value } );
    };

    // دالة غير متزامنة لمعالجة تغيير الصور (رفع الصور)
    async function handleChangeImages ( e )
    {
        // إضافة الصور الجديدة إلى قائمة الصور
        setImages( ( prev ) => [ ...prev, ...e.target.files ] );
        // تخزين الملفات المختارة
        const imagesAsFiles = e.target.files;

        // تكرار على كل ملف صورة
        for ( let i = 0; i < imagesAsFiles.length; i++ )
        {
            // زيادة العداد
            j.current++;
            // إنشاء كائن FormData لإرسال الملف
            const data = new FormData();
            data.append( "image", imagesAsFiles[ i ] ); // إضافة الصورة
            data.append( "product_id", id ); // إضافة معرف المنتج

            try
            {
                // إرسال طلب POST لرفع الصورة مع تتبع التقدم
                const res = await Axios.post( "/product-img/add", data, {
                    onUploadProgress: ( progressEvent ) =>
                    {
                        // حساب نسبة التحميل
                        const { loaded, total } = progressEvent;
                        const percent = Math.floor( ( loaded * 100 ) / total );
                        // تحديث شريط التقدم إذا كانت النسبة مضاعفة للـ 10
                        if ( percent % 10 === 0 && progress.current[ j.current ] )
                        {
                            progress.current[ j.current ].style.width = `${ percent }%`;
                            progress.current[ j.current ].setAttribute( "percent", `${ percent }%` );
                        }
                    },
                } );
                // تخزين معرف الصورة المرجعة من الخادم
                ids.current[ j.current ] = res.data.id;
            } catch ( error )
            {
                // طباعة خطأ رفع الصورة
                console.log( error );
            }
        }
    }

    // دالة غير متزامنة لحذف صورة من القائمة المحلية
    async function handleDeleteImage ( index, img )
    {
        // الحصول على معرف الصورة من المصفوفة
        const targetId = ids.current[ index ];
        try
        {
            // إرسال طلب DELETE لحذف الصورة من الخادم
            await Axios.delete( `/product-img/${ targetId }` );
            // إزالة الصورة من القائمة المحلية
            setImages( ( prev ) => prev.filter( ( image ) => image !== img ) );
            // إزالة المعرف من المصفوفة
            ids.current = ids.current.filter( ( i ) => i !== targetId );
            // تقليل العداد
            j.current--;
        } catch ( error )
        {
            // طباعة خطأ الحذف
            console.log( error );
        }
    }

    // دالة غير متزامنة لحذف صورة من الخادم مباشرة (بدون انتظار حفظ النموذج)
    async function handleDeleteServerImage ( imageId )
    {
        try
        {
            // إرسال طلب DELETE لحذف الصورة من الخادم
            await Axios.delete( `/product-img/${ imageId }` );
            // إزالة الصورة من قائمة صور الخادم
            setImagesFromServer( ( prev ) => prev.filter( ( img ) => img.id !== imageId ) );
        } catch ( error )
        {
            // طباعة خطأ الحذف
            console.log( "Error deleting image:", error );
        }
    }

    // إنشاء خيارات التصنيفات للقائمة المنسدلة
    const categoryOptions = categories.map( ( item ) => (
        <option key={ item.id } value={ item.id }>{ item.title }</option>
    ) );

    // عرض صور الخادم
    const serverImages = imagesFromServer.map( ( img ) => (
        <div className="server-image-chip" key={ img.id }>
            <img src={ img.image } alt="" /> {/* عرض الصورة */ }
            <span className="server-image-remove" onClick={ () => handleDeleteServerImage( img.id ) }>
                <FontAwesomeIcon icon={ faXmark } /> {/* أيقونة الحذف */ }
            </span>
        </div>
    ) );

    // عرض معاينة الصور الجديدة
    const imagesPreview = images.map( ( img, key ) => (
        <div className="image-preview-row" key={ key }>
            <div className="d-flex align-items-center gap-3">
                <img src={ URL.createObjectURL( img ) } alt="" /> {/* عرض الصورة */ }
                <div className="image-preview-meta">
                    <p>{ img.name }</p> {/* اسم الملف */ }
                    <p>
                        {/* عرض حجم الملف بالـ KB أو MB */ }
                        { img.size / 1024 < 900
                            ? ( img.size / 1024 ).toFixed( 2 ) + " KB"
                            : ( img.size / ( 1024 * 1024 ) ).toFixed( 2 ) + " MB" }
                    </p>
                </div>
            </div>
            <button type="button" className="image-remove-btn" onClick={ () => handleDeleteImage( key, img ) }>
                <FontAwesomeIcon icon={ faTrash } /> {/* أيقونة حذف */ }
            </button>
            <div className="custom-progress position-absolute" style={ { display: "none" } }>
                <span ref={ ( e ) => ( progress.current[ key ] = e ) } className="inner-progress" />
            </div>
        </div>
    ) );

    // عرض واجهة تعديل المنتج
    return (
        <>
            {/* عرض مكون التحميل إذا كانت الحالة true */ }
            { loading && <Loading /> }
            {/* حاوية النموذج */ }
            <div className="form-page-wrap">
                {/* نموذج تعديل المنتج */ }
                <Form className="form-page-card" onSubmit={ handleSave }>
                    <h3 className="form-page-title">{ t( 'products.editTitle' ) }</h3> {/* عنوان النموذج المترجم */ }

                    {/* حقل التصنيف */ }
                    <FormGroup className="mb-3" controlId="productCategory">
                        <Form.Label>{ t( 'products.categoryLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Select value={ formData.category } onChange={ handleChange } name="category" required>
                            <option disabled>{ t( 'products.selectCategory' ) }</option> {/* الخيار الافتراضي */ }
                            { categoryOptions } {/* خيارات التصنيفات */ }
                        </Form.Select>
                    </FormGroup>

                    {/* حقل عنوان المنتج */ }
                    <Form.Group className="mb-3" controlId="productTitle">
                        <Form.Label>{ t( 'products.titleLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.title } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="title" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'products.titlePlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل وصف المنتج */ }
                    <Form.Group className="mb-3" controlId="productDescription">
                        <Form.Label>{ t( 'products.descriptionLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.description } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="description" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'products.descriptionPlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل سعر المنتج */ }
                    <Form.Group className="mb-3" controlId="productPrice">
                        <Form.Label>{ t( 'products.priceLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.price } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="price" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'products.pricePlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل خصم المنتج */ }
                    <Form.Group className="mb-3" controlId="productDiscount">
                        <Form.Label>{ t( 'products.discountLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.discount } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="discount" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'products.discountPlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل نبذة عن المنتج */ }
                    <Form.Group className="mb-3" controlId="productAbout">
                        <Form.Label>{ t( 'products.aboutLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.About } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="About" // اسم الحقل
                            type="text" // نوع الإدخال نص
                            placeholder={ t( 'products.aboutPlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* حقل مخزون المنتج */ }
                    <Form.Group className="mb-3" controlId="productStock">
                        <Form.Label>{ t( 'products.stockLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <Form.Control
                            value={ formData.stock } // قيمة الحقل
                            onChange={ handleChange } // دالة التغيير
                            name="stock" // اسم الحقل
                            type="number" // نوع الإدخال رقم
                            placeholder={ t( 'products.stockPlaceholder' ) } // النص الافتراضي المترجم
                            required // الحقل مطلوب
                        />
                    </Form.Group>

                    {/* عرض صور الخادم إذا كانت موجودة */ }
                    { serverImages.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 mb-3">{ serverImages }</div>
                    ) }

                    {/* حقل رفع الصور */ }
                    <Form.Group className="mb-3" controlId="productImages">
                        <Form.Label>{ t( 'products.imagesLabel' ) }</Form.Label> {/* تسمية الحقل */ }
                        <div className="upload-dropzone is-active" onClick={ handleOpenImage }>
                            <span className="upload-dropzone-icon">
                                <FontAwesomeIcon icon={ faUpload } /> {/* أيقونة الرفع */ }
                            </span>
                            <p>{ t( 'products.uploadHere' ) }</p> {/* نص الرفع المترجم */ }
                        </div>
                        <Form.Control
                            ref={ openImage } // ربط المرجع
                            onChange={ handleChangeImages } // دالة التغيير
                            multiple // السماح باختيار عدة ملفات
                            type="file" // نوع الإدخال ملف
                            className="d-none" // إخفاء الحقل
                        />
                    </Form.Group>

                    {/* عرض معاينة الصور الجديدة */ }
                    { images.length > 0 && (
                        <div className="d-flex flex-column gap-2 mb-2">{ imagesPreview }</div>
                    ) }

                    {/* زر حفظ التعديلات */ }
                    <button className="form-page-submit" type="submit">
                        { t( 'products.save' ) } {/* نص الزر المترجم */ }
                    </button>
                </Form>
            </div>
        </>
    );
}